<template>
    <div>
    <div class="popup__header">
        <div class="title">Уход в рабочее время</div>
    </div>


    <div class="popup__content">
        <div class="mb40 mt40">
            <input-styled v-model="form.text.value"
                              :placeholder="'Укажите причину ухода, например «Выключали свет»'"
                              :isError="form.text.error"
                              :errorText="form.text.errorText"
                              :class="'inp-placeholder-showed'"
                              @focus="removeError(form.text)"
                              @input="removeError(form.text)"></input-styled>
        </div>
        <div class="mt40">
            <input @change="removeError(form.checkbox)" v-model="form.checkbox.value"  :class="{error:form.checkbox.error, 'repeat-error': form.checkbox.repeatError}" type="checkbox" id="checkbox">
            <label for="checkbox">Я подтверждаю, что предупредил команду о своем уходе и получил согласие руководства</label>
        </div>
        <div class="df df-space-between mt40">
            <submit-btn @click="send" tag="button" :type="btnType">
                запустить таймер
            </submit-btn>
        </div>
    </div>
</div>
</template>

<script>
    import Tooltip from '@/components/Tooltip.vue';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue';
    import InputStyled from '@/components/forms/InputStyled.vue';
    import {mapState} from "vuex";

    export default {
        name: "Leave",
        components: {
            Tooltip,
            SubmitBtn,
            InputStyled
        },
        props: {

        },
        watch: {

        },
        data: function () {
            return {
                btnType: 'normal',
                form: {
                    text: {
                        value: '',
                        error: false,
                        repeatError: false,
                    },
                    checkbox: {
                        value: false,
                        error: false,
                        repeatError: false,
                    },
                }
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                options: state => state.options,
            }),
        },
        mounted: function () {

        },
        emits: ['update:modelValue', 'calendarshow'],
        methods: {
            send(){
                let error = false;
                for(let field in this.form){
                    let errorField = false;
                    this.form[field].error = false;

                    if(field == 'text' && this.form[field].value.length == 0){
                        errorField = true;
                    }

                    if(field == 'checkbox' && this.form[field].value == false){
                        errorField = true;
                    }

                    if(errorField){
                        error = true;
                        setTimeout(() => {
                            this.form[field].error = true;
                        });
                    }
                }
                if(!error) {
                    this.btnType = 'load';
                    this.$store.dispatch('workers/leave',{timeType:'start', text:this.form.text.value}).then(() => {
                        this.btnType = 'ok';
                        setTimeout(()=>{
                            this.$store.commit('popups/close', {name: this.popups.leave.name});
                        }, this.options.delayPopupClose);
                    },()=>{});
                }
            },
            removeError(form) {
                form.error = false;
            },
        },
    }
</script>

<style scoped>
</style>
